import {DevicePushState} from '../enums/DevicePushState';

export const getDefaultState = (): DevicePushState => {
  if (typeof window === 'undefined') {
    return DevicePushState.BLOCKED;
  } else {
    if (typeof window !== undefined && !('Notification' in window)) {
      return DevicePushState.BLOCKED;
    }

    switch (Notification.permission) {
      case 'denied':
        return DevicePushState.BLOCKED;
      case 'granted':
        return DevicePushState.SENT;
      default:
        return DevicePushState.NOT_SENT;
    }
  }
};
